var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      staticClass: "py-1 px-2",
      attrs: { align: "center", justify: "space-between" },
    },
    [
      _c(
        "v-col",
        { attrs: { cols: "11" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "space-between" } },
            [
              typeof _vm.currentRule.operands !== "undefined"
                ? _c(
                    "v-col",
                    { staticClass: "pa-0 pr-3", attrs: { cols: "5" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.currentRule.operands,
                          "return-object": "",
                          outlined: "",
                          "single-line": "",
                          dense: "",
                          "hide-details": "",
                          "append-icon": "mdi-chevron-down",
                        },
                        model: {
                          value: _vm.currentRule.operand,
                          callback: function ($$v) {
                            _vm.$set(_vm.currentRule, "operand", $$v)
                          },
                          expression: "currentRule.operand",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.currentRule.isCombined
                ? [
                    typeof _vm.currentRule.operators !== "undefined" &&
                    _vm.currentRule.operators.length > 1
                      ? _c(
                          "v-col",
                          { staticClass: "pa-0 pr-3", attrs: { cols: "3" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                items: _vm.currentRule.operators,
                                "return-object": "",
                                outlined: "",
                                "single-line": "",
                                dense: "",
                                "hide-details": "",
                                "append-icon": "mdi-chevron-down",
                              },
                              model: {
                                value: _vm.currentRule.operator,
                                callback: function ($$v) {
                                  _vm.$set(_vm.currentRule, "operator", $$v)
                                },
                                expression: "currentRule.operator",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.currentRule.type === "numeric" &&
                    _vm.currentRule.operator === "rango"
                      ? _c(
                          "v-col",
                          { attrs: { cols: "9" } },
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { staticClass: "pa-0", attrs: { cols: "4" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        prefix: "desde",
                                        oninput:
                                          "this.value=this.value.replace(/[^0-9.]/g,'');",
                                        "append-icon":
                                          _vm.currentRule.appendIcon,
                                        outlined: "",
                                        required: "",
                                        "single-line": "",
                                        dense: "",
                                        "hide-details": "",
                                      },
                                      model: {
                                        value: _vm.currentRule.value,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.currentRule,
                                            "value",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "currentRule.value",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "pa-0 pl-3",
                                    attrs: { cols: "4" },
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        prefix: "hasta",
                                        oninput:
                                          "this.value=this.value.replace(/[^0-9.]/g,'');",
                                        "append-icon":
                                          _vm.currentRule.appendIcon,
                                        outlined: "",
                                        required: "",
                                        "single-line": "",
                                        dense: "",
                                        "hide-details": "",
                                        error: _vm.error.active,
                                      },
                                      on: { input: _vm.validate },
                                      model: {
                                        value: _vm.currentRule.value2,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.currentRule,
                                            "value2",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "currentRule.value2",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.error.msg.length
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-block red--text caption ml-n2 mt-4 mb-n4",
                                  },
                                  [_vm._v(_vm._s(_vm.error.msg))]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.currentRule.type === "date" &&
                    _vm.currentRule.operator === "rango"
                      ? _c(
                          "v-col",
                          { attrs: { cols: "9" } },
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { staticClass: "pa-0", attrs: { cols: "4" } },
                                  [
                                    _c(
                                      "v-menu",
                                      {
                                        attrs: {
                                          "close-on-content-click": false,
                                          "offset-y": "",
                                          "nudge-bottom": 10,
                                          transition: "slide-y-transition",
                                          "max-width": "280",
                                          "z-index": "1000",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "v-text-field",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            prefix: "desde",
                                                            "append-icon":
                                                              "mdi-calendar-blank",
                                                            outlined: "",
                                                            "single-line": "",
                                                            dense: "",
                                                            readonly: "",
                                                            "hide-details": "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.currentRule
                                                                .value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.currentRule,
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "currentRule.value",
                                                          },
                                                        },
                                                        "v-text-field",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4109698367
                                        ),
                                        model: {
                                          value: _vm.startDateMenu,
                                          callback: function ($$v) {
                                            _vm.startDateMenu = $$v
                                          },
                                          expression: "startDateMenu",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-date-picker",
                                          {
                                            attrs: {
                                              "no-title": "",
                                              "first-day-of-week": 1,
                                              type: "date",
                                              locale: "es",
                                              width: "270",
                                              color: "grey-900",
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.startDateMenu = false
                                              },
                                            },
                                            model: {
                                              value: _vm.currentRule.value,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.currentRule,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression: "currentRule.value",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              { staticClass: "pt-0 mb-1 px-5" },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "body-1",
                                                    attrs: {
                                                      ripple: false,
                                                      text: "",
                                                      color: "grey-900",
                                                    },
                                                    on: {
                                                      click: () => {
                                                        _vm.currentRule.value =
                                                          null
                                                        _vm.startDateMenu = false
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Limpiar")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "pa-0 pl-3",
                                    attrs: { cols: "4" },
                                  },
                                  [
                                    _c(
                                      "v-menu",
                                      {
                                        attrs: {
                                          "close-on-content-click": false,
                                          "offset-y": "",
                                          "nudge-bottom": 10,
                                          transition: "slide-y-transition",
                                          "max-width": "280",
                                          "z-index": "1000",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "v-text-field",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            prefix: "hasta",
                                                            "append-icon":
                                                              "mdi-calendar-blank",
                                                            outlined: "",
                                                            "single-line": "",
                                                            dense: "",
                                                            readonly: "",
                                                            "hide-details": "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.currentRule
                                                                .value2,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.currentRule,
                                                                "value2",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "currentRule.value2",
                                                          },
                                                        },
                                                        "v-text-field",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3877828945
                                        ),
                                        model: {
                                          value: _vm.endDateMenu,
                                          callback: function ($$v) {
                                            _vm.endDateMenu = $$v
                                          },
                                          expression: "endDateMenu",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-date-picker",
                                          {
                                            attrs: {
                                              min: _vm.currentRule.value,
                                              "no-title": "",
                                              "first-day-of-week": 1,
                                              type: "date",
                                              locale: "es",
                                              width: "270",
                                              color: "grey-900",
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.endDateMenu = false
                                              },
                                            },
                                            model: {
                                              value: _vm.currentRule.value2,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.currentRule,
                                                  "value2",
                                                  $$v
                                                )
                                              },
                                              expression: "currentRule.value2",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              { staticClass: "mb-1 px-5" },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "body-1",
                                                    attrs: {
                                                      ripple: false,
                                                      text: "",
                                                      color: "grey-900",
                                                    },
                                                    on: {
                                                      click: () => {
                                                        _vm.currentRule.value2 =
                                                          null
                                                        _vm.endDateMenu = false
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Limpiar")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-col",
                      { staticClass: "pa-0" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pa-0", attrs: { cols: "8" } },
                          [
                            _vm.currentRule.type === "text"
                              ? _c("v-text-field", {
                                  attrs: {
                                    disabled:
                                      _vm.currentRule.operator === "no tiene",
                                    placeholder:
                                      _vm.currentRule.placeholder ===
                                      "Escribe el RUT"
                                        ? _vm.$t("generals.Escribe el RUT")
                                        : _vm.currentRule.placeholder,
                                    outlined: "",
                                    required: "",
                                    "single-line": "",
                                    dense: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.currentRule.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.currentRule,
                                        "value",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "currentRule.value",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { staticClass: "pa-0", attrs: { cols: "4" } },
                          [
                            _vm.currentRule.id === "prefix"
                              ? _c("v-text-field", {
                                  attrs: {
                                    oninput:
                                      "this.value=this.value.replace(/[^a-zA-Z0-9]/g,'');",
                                    outlined: "",
                                    required: "",
                                    "single-line": "",
                                    dense: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.currentRule.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.currentRule,
                                        "value",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "currentRule.value",
                                  },
                                })
                              : _vm.currentRule.type === "numeric" &&
                                _vm.currentRule.operator !== "rango"
                              ? [
                                  _vm.currentRule.label === "Serie"
                                    ? _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          "hide-details": "",
                                          placeholder:
                                            _vm.currentRule.placeholder,
                                        },
                                        model: {
                                          value: _vm.currentRule.value,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.currentRule,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "currentRule.value",
                                        },
                                      })
                                    : _c("v-text-field", {
                                        attrs: {
                                          oninput:
                                            "this.value=this.value.replace(/[^0-9.]/g,'');",
                                          outlined: "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          "hide-details": "",
                                          placeholder:
                                            _vm.currentRule.placeholder,
                                        },
                                        model: {
                                          value: _vm.currentRule.value,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.currentRule,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "currentRule.value",
                                        },
                                      }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm.currentRule.type === "date" &&
                        _vm.currentRule.operator !== "rango"
                          ? _c(
                              "v-col",
                              { staticClass: "pa-0", attrs: { cols: "4" } },
                              [
                                _c(
                                  "v-menu",
                                  {
                                    attrs: {
                                      "close-on-content-click": false,
                                      "offset-y": "",
                                      "nudge-bottom": 10,
                                      transition: "slide-y-transition",
                                      "max-width": "280",
                                      "z-index": "1000",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-text-field",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        "append-icon":
                                                          "mdi-calendar-blank",
                                                        outlined: "",
                                                        "single-line": "",
                                                        dense: "",
                                                        readonly: "",
                                                        "hide-details": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.currentRule.value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.currentRule,
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "currentRule.value",
                                                      },
                                                    },
                                                    "v-text-field",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2567268042
                                    ),
                                    model: {
                                      value: _vm.startDateMenu,
                                      callback: function ($$v) {
                                        _vm.startDateMenu = $$v
                                      },
                                      expression: "startDateMenu",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-date-picker",
                                      {
                                        attrs: {
                                          "no-title": "",
                                          "first-day-of-week": 1,
                                          type: "date",
                                          locale: "es",
                                          width: "270",
                                          color: "grey-900",
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.startDateMenu = false
                                          },
                                        },
                                        model: {
                                          value: _vm.currentRule.value,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.currentRule,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "currentRule.value",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "pt-0 mb-1 px-5" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "body-1",
                                                attrs: {
                                                  ripple: false,
                                                  text: "",
                                                  color: "grey-900",
                                                },
                                                on: {
                                                  click: () => {
                                                    _vm.currentRule.value = null
                                                    _vm.startDateMenu = false
                                                  },
                                                },
                                              },
                                              [_vm._v("Limpiar")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.currentRule.type === "radio"
                          ? _c(
                              "v-radio-group",
                              {
                                staticClass: "mt-n1 py-0",
                                attrs: { row: "", "hide-details": "" },
                                model: {
                                  value: _vm.currentRule.value,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.currentRule, "value", $$v)
                                  },
                                  expression: "currentRule.value",
                                },
                              },
                              _vm._l(
                                _vm.currentRule.choices,
                                function (choice) {
                                  return _c("v-radio", {
                                    key: choice.value,
                                    attrs: {
                                      label: choice.label,
                                      value: choice.value,
                                      dense: "",
                                      ripple: false,
                                    },
                                  })
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                        _vm.currentRule.type === "select"
                          ? [
                              _c(
                                "v-col",
                                { staticClass: "pa-0", attrs: { cols: "8" } },
                                [
                                  _c("v-autocomplete", {
                                    class: {
                                      isMultiple: _vm.currentRule.isMultiple,
                                    },
                                    attrs: {
                                      multiple: _vm.currentRule.isMultiple,
                                      items: _vm.currentRule.choices,
                                      "no-data-text": "Sin información",
                                      "item-text": "label",
                                      "item-value": "value",
                                      outlined: "",
                                      "single-line": "",
                                      dense: "",
                                      "hide-details": "",
                                      "append-icon": "mdi-chevron-down",
                                      placeholder: _vm.currentRule.placeholder,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function ({ props }) {
                                            return [
                                              props ? _c("span", {}) : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1879759739
                                    ),
                                    model: {
                                      value: _vm.select,
                                      callback: function ($$v) {
                                        _vm.select = $$v
                                      },
                                      expression: "select",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.currentRule.isMultiple
                                ? _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { staticClass: "pa-0 mt-2" },
                                        [
                                          _vm._l(
                                            _vm.select?.slice(0, 3),
                                            function (m, i) {
                                              return _c(
                                                "v-chip",
                                                {
                                                  key: `${m}${i}`,
                                                  staticClass:
                                                    "mr-2 mb-2 font-weight-light overline chip-users",
                                                  attrs: {
                                                    close: "",
                                                    color: "blue-100",
                                                    small: "",
                                                    label: "",
                                                    "close-icon": "mdi-close",
                                                  },
                                                  on: {
                                                    "click:close": function (
                                                      $event
                                                    ) {
                                                      return _vm.remove(m, i)
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currentRule.choices?.find(
                                                          ({ value }) =>
                                                            value === m
                                                        )?.label
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          _vm.select?.length > 3
                                            ? [
                                                _c(
                                                  "v-chip",
                                                  {
                                                    staticClass:
                                                      "mr-2 mb-2 font-weight-light overline chip-users",
                                                    attrs: {
                                                      color: "blue-100",
                                                      small: "",
                                                      label: "",
                                                      "close-icon": "mdi-close",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.select?.length - 3
                                                        ) +
                                                        " más "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm.currentRule.dependent && _vm.currentRule.id === "branch_id"
                ? [
                    _c(
                      "v-col",
                      { staticClass: "pa-0 pb-5", attrs: { cols: "11" } },
                      [
                        _c(
                          "v-row",
                          { attrs: { "no-gutters": "" } },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "pa-0 pr-3",
                                attrs: { cols: "6" },
                              },
                              [
                                _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    typeof _vm.currentRule.operators_branch !==
                                      "undefined" &&
                                    _vm.currentRule.operators_branch.length > 1
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "pa-0 pr-3",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                items:
                                                  _vm.currentRule
                                                    .operators_branch,
                                                "return-object": "",
                                                outlined: "",
                                                "single-line": "",
                                                dense: "",
                                                "hide-details": "",
                                                "append-icon":
                                                  "mdi-chevron-down",
                                              },
                                              model: {
                                                value:
                                                  _vm.currentRule
                                                    .operator_branch,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.currentRule,
                                                    "operator_branch",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "currentRule.operator_branch",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-col",
                                      { staticClass: "pa-0" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            prefix: "Tienda",
                                            outlined: "",
                                            required: "",
                                            "single-line": "",
                                            dense: "",
                                            "hide-details": "",
                                            disabled:
                                              _vm.currentRule
                                                .operator_branch === "no tiene",
                                          },
                                          model: {
                                            value: _vm.currentRule.value,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.currentRule,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression: "currentRule.value",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "pa-0 pl-3",
                                attrs: { cols: "6" },
                              },
                              [
                                _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    typeof _vm.currentRule.operators_cpos !==
                                      "undefined" &&
                                    _vm.currentRule.operators_cpos.length > 1
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "pa-0 pr-3",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                items:
                                                  _vm.currentRule
                                                    .operators_cpos,
                                                "return-object": "",
                                                outlined: "",
                                                "single-line": "",
                                                dense: "",
                                                "hide-details": "",
                                                "append-icon":
                                                  "mdi-chevron-down",
                                                disabled:
                                                  (_vm.currentRule.id ===
                                                    "branch_id" &&
                                                    !_vm.currentRule.value
                                                      ?.length) ||
                                                  _vm.currentRule
                                                    .operator_branch ===
                                                    "no tiene",
                                              },
                                              model: {
                                                value:
                                                  _vm.currentRule.operator_cpos,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.currentRule,
                                                    "operator_cpos",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "currentRule.operator_cpos",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-col",
                                      { staticClass: "pa-0" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            prefix: "Caja",
                                            disabled:
                                              (_vm.currentRule.id ===
                                                "branch_id" &&
                                                !_vm.currentRule.value
                                                  ?.length) ||
                                              _vm.currentRule
                                                .operator_branch === "no tiene",
                                            outlined: "",
                                            required: "",
                                            "single-line": "",
                                            dense: "",
                                            "hide-details": "",
                                          },
                                          model: {
                                            value: _vm.currentRule.value2,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.currentRule,
                                                "value2",
                                                $$v
                                              )
                                            },
                                            expression: "currentRule.value2",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm.currentRule.dependent && _vm.currentRule.id === "date"
                ? [
                    _c(
                      "v-col",
                      { staticClass: "pt-5", attrs: { cols: "10" } },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { staticClass: "pa-0", attrs: { cols: "4" } },
                              [
                                _c(
                                  "v-menu",
                                  {
                                    attrs: {
                                      "close-on-content-click": false,
                                      "offset-y": "",
                                      "nudge-bottom": 10,
                                      transition: "slide-y-transition",
                                      "max-width": "280",
                                      "z-index": "1000",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      prefix: "Fecha",
                                                      "append-icon":
                                                        "mdi-calendar-blank",
                                                      outlined: "",
                                                      "single-line": "",
                                                      dense: "",
                                                      readonly: "",
                                                      "hide-details": "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentRule.value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.currentRule,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentRule.value",
                                                    },
                                                  },
                                                  "v-text-field",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.startDateMenu,
                                      callback: function ($$v) {
                                        _vm.startDateMenu = $$v
                                      },
                                      expression: "startDateMenu",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-date-picker",
                                      {
                                        attrs: {
                                          "no-title": "",
                                          "first-day-of-week": 1,
                                          type: "date",
                                          locale: "es",
                                          width: "270",
                                          color: "grey-900",
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.startDateMenu = false
                                          },
                                        },
                                        model: {
                                          value: _vm.currentRule.value,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.currentRule,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "currentRule.value",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          { staticClass: "pt-0 mb-1 px-5" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "body-1",
                                                attrs: {
                                                  ripple: false,
                                                  text: "",
                                                  color: "grey-900",
                                                },
                                                on: {
                                                  click: () => {
                                                    _vm.currentRule.value = null
                                                    _vm.startDateMenu = false
                                                  },
                                                },
                                              },
                                              [_vm._v("Limpiar")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { staticClass: "pa-0 pl-3" },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    prefix: "Nombre de archivo",
                                    disabled:
                                      _vm.currentRule.id === "date" &&
                                      !_vm.currentRule.value?.length,
                                    outlined: "",
                                    required: "",
                                    "single-line": "",
                                    dense: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.currentRule.value2,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.currentRule, "value2", $$v)
                                    },
                                    expression: "currentRule.value2",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }